export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex">
      <a
        href="tel:05362771709"
        className="flex-1 flex items-center justify-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold text-sm py-4 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-phone-fill text-base"></i>
        Hemen Ara
      </a>
      <a
        href="https://wa.me/905362771709"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="flex-1 flex items-center justify-center gap-2 bg-[#0f1923] text-white font-body font-semibold text-sm py-4 cursor-pointer whitespace-nowrap border-l border-white/10"
      >
        <i className="ri-whatsapp-fill text-base"></i>
        WhatsApp
      </a>
    </div>
  );
}
